define('views/components/customer_note/customer_notes',['require','views/base/collection_view','views/components/customer_note/customer_note_list','text!templates/components/customer_note/customer_notes.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/customer_note/customer_note_list');

    var temp = require("text!templates/components/customer_note/customer_notes.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container customer-note-grid-container',

        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});

